import { createContext } from 'react';

interface IEPGContext {
  sheetStartTimeMs: number;
  sheetEndTimeMs: number;
  currentTimeMs: number;
  isLoading?: boolean;
}

export const EPGContext = createContext<IEPGContext>(null);

EPGContext.displayName = 'EPGContext';
